import {
  getItemOrDefaultToValue,
  getPersonName,
  getPhoneNumber,
} from 'utils/details';
import isEmpty from 'lodash/isEmpty';
import services_suite from 'static/services.json';
import { DEFAULT_EMPTY_VALUE } from '../../constants';

/**
 * Filter to the allowed services
 * @param {[]}services - the list of services that the company has.
 * @returns {[]} - the filtered list that only contains the supported services defined in @link static/services.json
 */
export const getSupportedServices = services => {
  if (!services || services.length < 1) return DEFAULT_EMPTY_VALUE;
  const supportedServices = services_suite.reduce((acc, curr) => {
    const [servicesData] = [curr].filter(item => services.includes(item.id));
    if (servicesData) {
      const payload = {
        id: servicesData.id,
        name: servicesData.name,
        icon: servicesData.icon,
      };
      return [...acc, payload];
    } else return [...acc];
  }, []);

  return supportedServices.sort((a, b) => a.name.localeCompare(b.name));
};

export const transform = securityCompany => {
  return {
    generalInfo: {
      name: {
        type: 'text',
        value: getItemOrDefaultToValue(
          securityCompany,
          'name',
          DEFAULT_EMPTY_VALUE,
        ),
      },
      operationalNumber: {
        type: 'text',
        value: getPhoneNumber(
          getItemOrDefaultToValue(securityCompany, 'operationPhone'),
        ),
      },
      bookingNumber: {
        type: 'text',
        value: getPhoneNumber(
          getItemOrDefaultToValue(securityCompany, 'bookingPhone'),
        ),
      },
      accountHolder: {
        type: 'array',
        value: [
          {
            display: getPersonName(
              securityCompany.contact.general,
              DEFAULT_EMPTY_VALUE,
            ),
          },

          {
            display: getItemOrDefaultToValue(
              securityCompany.contact.general,
              'email',
              DEFAULT_EMPTY_VALUE,
            ),
          },
          {
            display: getPhoneNumber(
              getItemOrDefaultToValue(
                securityCompany.contact.general,
                'phoneNumber',
              ),
            ),
          },
        ],
      },
    },
    detailedInfo: {
      noOfManagers: {
        type: 'text',
        value: getItemOrDefaultToValue(
          securityCompany.resourceCount,
          'managers',
          0,
        ),
      },
      noOfSupervisors: {
        type: 'text',
        value: getItemOrDefaultToValue(
          securityCompany.resourceCount,
          'supervisors',
          0,
        ),
      },
      noOfResponders: {
        type: 'text',
        value: getItemOrDefaultToValue(
          securityCompany.resourceCount,
          'responders',
          0,
        ),
      },
      noOfGuards: {
        type: 'text',
        value: getItemOrDefaultToValue(
          securityCompany.resourceCount,
          'guards',
          0,
        ),
      },
      noOfDrivers: {
        type: 'text',
        value: getItemOrDefaultToValue(
          securityCompany.resourceCount,
          'drivers',
          0,
        ),
      },
      noOfCleaners: {
        type: 'text',
        value: getItemOrDefaultToValue(
          securityCompany.resourceCount,
          'cleaners',
          0,
        ),
      },
      noOfMaintainers: {
        type: 'text',
        value: getItemOrDefaultToValue(
          securityCompany.resourceCount,
          'maintainers',
          0,
        ),
      },
      noOfSites: {
        type: 'text',
        value: getItemOrDefaultToValue(
          securityCompany.resourceCount,
          'sites',
          0,
        ),
      },
      supportedServices: {
        type: 'service-info',
        value: !isEmpty(securityCompany.services)
          ? [
              {
                data: getSupportedServices(securityCompany.services),
              },
            ]
          : DEFAULT_EMPTY_VALUE,
      },
    },
    others: {
      image: { value: getItemOrDefaultToValue(securityCompany, 'imageUrl') },
      archived: { value: getItemOrDefaultToValue(securityCompany, 'archived') },
    },
  };
};
